module.exports = __webpack_public_path__ + "51c3a3fd267013568c3591724c43bc49.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/containers/Camp/camp2.jpeg
// module id = 1136
// module chunks = 0